<template>
    <modal id="create-partner-category-modal"
            title="Create partner category"
            :visible="show"
            ok-title="Proceed"
            :ok-disabled="!categoryNameState"
            @ok="createCategory"
            @hide="clearInput"
            class="lx-global-modal"
            >
        <b-container fluid>
            <b-row class="my-1">
                <b-col sm="2">
                    <label for="input-name">Name:</label>
                </b-col>
                <b-col sm="10">
                    <b-form-input 
                        id="input-name"
                        v-model="categoryName"
                        :state="categoryNameState"
                        placeholder="Enter partner category name"
                        aria-describedby="input-live-help input-live-feedback"
                    />
                </b-col>
            </b-row>
        </b-container>
    </modal>
</template>

<script>
    import Modal from '../../../generic/modal/modal.vue';
    import API from '../../../.././api';
    
    export default {
        name: 'CreateCategoryModal',
        components: {
            Modal
        },        
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            categoryNameState() {
                return this.categoryName.length > 0 ? true : false
            }
        },
        data() {
            return {
                categoryName: '',
            }
        },
        methods: {
            clearInput() {
                this.categoryName = '';
            },
            async createCategory() {
                try {
                    this.$emit('startCreating');
                    await API.post(
                        `/app/partner-cards/category/`,
                        {
                            name: this.categoryName,
                        }
                    );
                    const message = 'Partner category has been created';
                    this.successToast({text: message})
                }
                catch (error) {
                    this.errorToast({text: 'Could not create category.'})
                }
                this.$emit('endCreating');
                this.clearInput();
            }
        }
    }
</script>


<style lang="scss" scoped>
:deep(.container-fluid) {
    padding-left: 0px !important;
}

:deep(label) {
    margin-top: 0.4rem;
}

:deep(.btn-primary.disabled),
:deep(.btn-primary:disabled) {
    cursor: not-allowed;
}
</style>